import { Feed, Locale, Schedule } from "@vviinn/user-managment-client-ts";
import {
  scheduleSiteFeed,
  triggerSiteFeed,
  RequestHandlerParams,
  fetchSiteFeed,
  fetchCatalogDetails,
} from "../store";
import { responseNotification } from "../components/Notifications";

const DEFAULT_LOCALE: Locale = "de_DE";

const actionDescriptions = {
  scheduleSiteFeed: {
    info: `Changing import settings`,
    successMessage: "Import settings changed",
    errorMessage: "Could not change import settings",
  },
  triggerSiteFeed: {
    info: "Importing Feed(s). It may take a while.",
    successMessage: "Feed(s) import finished",
    errorMessage: "Could not import feed(s).",
  },
};

export const handleFeed = (
  params: RequestHandlerParams,
  companyId?: string,
  siteId?: number,
) => {
  const { getApi, notify, dispatch } = params;

  return {
    async handleScheduleFeed(
      isScheduling: boolean,
      scheduleTime: string,
      feeds: Feed[],
    ) {
      if (!companyId || !siteId) return false;
      const api = await getApi();
      const scheduleData = scheduleTime
        .split(":")
        .map((item) => parseInt(item));
      const scheduleAt = isScheduling
        ? {
            hour: scheduleData[0],
            minute: scheduleData[1],
            timezone: "Europe/Berlin",
          }
        : undefined;
      const url =
        feeds.find(({ entityType }) => entityType === "product")?.url ?? "";
      const schedule: Schedule = {
        siteId: siteId,
        feedUrl: url,
        feeds: feeds,
        locale: DEFAULT_LOCALE,
        isActive: isScheduling,
        scheduleAt: scheduleAt,
      };
      const { info, successMessage, errorMessage } =
        actionDescriptions.scheduleSiteFeed;
      notify("Info", info);
      const response = await dispatch(
        scheduleSiteFeed({
          api,
          value: {
            companyId,
            siteId,
            schedule,
          },
        }),
      );
      return responseNotification(notify, !!response?.payload, {
        successMessage,
        errorMessage,
      });
    },

    async handleTriggerFeed() {
      if (!companyId || !siteId) return;
      const api = await getApi();
      const { info, successMessage, errorMessage } =
        actionDescriptions.triggerSiteFeed;
      notify("Info", info);
      const response = await dispatch(
        triggerSiteFeed({
          api,
          value: { companyId, siteId },
        }),
      );
      return responseNotification(notify, !!response?.payload, {
        successMessage,
        errorMessage,
      });
    },

    async handleRefreshFeed() {
      if (!companyId || !siteId) return;
      const api = await getApi();
      dispatch(
        fetchSiteFeed({
          api,
          value: { companyId, siteId },
        }),
      );
      dispatch(
        fetchCatalogDetails({
          api,
          value: { companyId, siteId },
        }),
      );
    },
  };
};
